import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "calendar-days" }

import { Locale, format, addDays } from 'date-fns'

  interface Props {
    startDate: Date
    localeOptions: Locale
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    startDate: null,
    localeOptions: null
  },
  setup(__props: any) {

const props = __props as {
    startDate: Date
    localeOptions: Locale
  }

  

  const days = []
  for (let i = 0; i < 7; i++) {
    days.push(addDays(props.startDate, i))
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(days, (day, index) => {
      return _createElementVNode("div", {
        class: "calendar-day",
        key: index
      }, _toDisplayString(_unref(format)(day, 'EEE', { locale: __props.localeOptions })), 1)
    }), 64))
  ]))
}
}

})